/**
 * Map Italian backend error messages to i18n keys so the frontend
 * can render them in the current locale. Centralized to keep the
 * backend strings stable while allowing EN rendering.
 */
const MAP = [
  // email already in use
  [/già un account con questa email/i, "errors.emailExists"],
  // trial already used (consumed)
  [/già utilizzato la prova/i, "errors.trialNotAvailable"],
  // service unavailable (HMAC key etc.)
  [/servizio non disponibile|hmac key/i, "errors.serverBusy"],
  // invalid credentials
  [/credenziali non valide/i, "errors.invalidCredentials"],
  // password too short
  [/password.*corta|minimo 6/i, "errors.passwordWeak"],
  // email invalid
  [/email non valida/i, "errors.emailInvalid"],
  // require auth
  [/devi accedere/i, "errors.requireAuth"],
  // too many attempts
  [/troppi tentativi/i, "errors.tooManyAttempts"],
  // access blocked
  [/accesso.*limitato|abbonamento richiesto/i, "errors.accessBlocked"],
];

/**
 * @param {string|object|undefined} detail — backend FastAPI "detail" field
 * @param {(k:string)=>string} t — translator (useT)
 * @returns {string} localized message, or the original detail if unmapped.
 */
export function mapBackendError(detail, t) {
  if (!detail) return t("errors.unknown");
  const text = typeof detail === "string" ? detail : (detail?.msg || JSON.stringify(detail));
  for (const [re, key] of MAP) {
    if (re.test(text)) return t(key);
  }
  return text; // unmapped → show as-is (likely already a user-facing IT phrase)
}
